import {initPersonalAccountGroups} from "../account-cabinet-groups/account-cabinet-groups";
import {initPersonalAccountGroup} from "../account-cabinet-group-info/account-cabinet-group-info";
import {
    initPersonalAccountStudentsProgress
} from "../account-cabinet-students-progress/account-cabinet-students-progress";
import {initPersonalAccountTabProgress} from "../account-cabinet-self-progress/account-cabinet-self-progress";
import {
    initPersonalAccountTabProgressHistory
} from "../account-cabinet-self-progress/account-cabinet-self-progress-history/account-cabinet-self-progress-history";
import {
    initPersonalAccountTabProgressProfile
} from "../account-cabinet-self-progress/account-cabinet-self-progress-profile/account-cabinet-self-progress-profile";
import axios from "axios";
import {
    initPersonalAccountTabProgressMy
} from "../account-cabinet-self-progress/account-cabinet-self-progress-my/account-cabinet-self-progress-my";


const DATA_ATTR = 'data-account-cabinet';
const TAB_ATTR = `${DATA_ATTR}-nav`;    // data-account-cabinet-nav
const PANEL_ATTR = `${DATA_ATTR}-panel`;  // data-account-cabinet-panel
const CLASS_PREFIX = 'account-cabinet';

const OPEN_ATTR = `${DATA_ATTR}-open`; // optional: elements that open panels: data-account-cabinet-open="panel-name"
const PAYLOAD_ATTR = `${DATA_ATTR}-payload`; // optional json or string
const ACTIVE_TAB_CLASS = `${CLASS_PREFIX}__nav-item--active`;
const ACTIVE_PANEL_CLASS = `${CLASS_PREFIX}__panel--active`;

const $container = document.querySelector(`[${DATA_ATTR}]`);
if ($container) initPersonalAccount($container);

function initPersonalAccount($container) {
    const $loader = $container.querySelector(`[${DATA_ATTR}-loader]`);

    // Коллекции
    let $tabs = Array.from($container.querySelectorAll(`[${TAB_ATTR}]`));
    let $panels = Array.from($container.querySelectorAll(`[${PANEL_ATTR}]`));
    let isfirstInit = true;

    const $navContainer = $container.querySelector(`[${DATA_ATTR}-nav-container]`);
    const $navBack = $container.querySelector(`[${DATA_ATTR}-nav-back]`);
    const $contentContainer = $container.querySelector(`[${DATA_ATTR}-content-container]`);

    // registry: name -> {el, initFn, initialized}
    const panels = new Map();

    // internal event handlers map (for api.on/off)
    const listeners = new Map();
    const initializers = {};
    let userData = {};

    function findPanelEl(name) {
        return $panels.find(p => p.getAttribute(PANEL_ATTR) === name) ||
            $container.querySelector(`[${PANEL_ATTR}="${name}"]`);
    }

    // Register panels based on DOM found initially
    function scanPanels() {
        $tabs = Array.from($container.querySelectorAll(`[${TAB_ATTR}]`));
        $panels = Array.from($container.querySelectorAll(`[${PANEL_ATTR}]`));

        $panels.forEach($p => {
            const name = $p.getAttribute(PANEL_ATTR);
            if (!panels.has(name)) {
                panels.set(name, {
                    el: $p,
                    initFn: initializers[name] || null,
                    initialized: false
                });
            } else {
                panels.get(name).el = $p;
            }
        });

        // also ensure tabs are present in map for convenience (no el needed)
        $tabs.forEach($t => {
            const name = $t.getAttribute(TAB_ATTR);
            if (!panels.has(name)) {
                panels.set(name, {
                    el: findPanelEl(name) || null,
                    initFn: initializers[name] || null,
                    initialized: false
                });
            } else {
                // already exists
            }
        });
    }

    // Render/call initializer for panel
    async function renderPanel(name, payload) {
        $loader.style.display = 'flex';
        if (!name) return;

        if (isfirstInit) {
            isfirstInit = false;
            $contentContainer.classList.add('m-hide');
        }
        else {
            $navContainer.classList.add('m-hide');
            $navBack.classList.add('m-show');
            $contentContainer.classList.remove('m-hide');
        }

        const entry = panels.get(name) || {el: findPanelEl(name), initFn: null, initialized: false};
        // try to update el if not present
        if (!entry.el) entry.el = findPanelEl(name);

        // if initializer exists, call it
        if (typeof entry.initFn === 'function') {
            try {
                const maybePromise = entry.initFn(entry.el, payload);
                if (maybePromise && typeof maybePromise.then === 'function') {
                    await maybePromise;
                }
                entry.initialized = true;
                panels.set(name, entry);
                // fire render event
                emitDOMEvent('account-cabinet:panel-rendered', {name, payload, panel: entry.el});
                emit('panel:rendered', {name, payload, panel: entry.el});
            } catch (err) {
                console.error(`account-cabinet: error while rendering panel "${name}"`, err);
            }
        } else {
            // No initializer — still emit event so others can react
            emitDOMEvent('account-cabinet:panel-rendered', {name, payload, panel: entry.el});
            emit('panel:rendered', {name, payload, panel: entry.el});
        }
    }

    // Set active panel (updates tabs/panels aria & classes), and renders target panel
    async function setActive(name, payload = {}, opts = {}) {
        if (!name) return;
        scanPanels(); // ensure map is current (in case panels were added later)

        // Update tabs
        $tabs.forEach(tab => {
            const tabName = tab.getAttribute(TAB_ATTR);
            const active = tabName === name;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.classList.toggle(ACTIVE_TAB_CLASS, active);
        });

        // Update panels
        $panels.forEach(panel => {
            const panelName = panel.getAttribute(PANEL_ATTR);
            const visible = panelName === name;
            panel.setAttribute('aria-hidden', visible ? 'false' : 'true');
            panel.classList.toggle(ACTIVE_PANEL_CLASS, visible);
        });

        // render target panel
        await renderPanel(name, payload);

        // Dispatch events
        emitDOMEvent('account-cabinet:activated', {name, payload});
        emit('activated', {name, payload});

        if (!opts.silent) {
            // for backwards compatibility, also set focus to first interactive element if requested
            if (opts.focus !== false) {
                const $panelEl = findPanelEl(name);
                if ($panelEl) {
                    const focusable = $panelEl.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                    if (focusable) focusable.focus();
                }
            }
        }
    }

    // Helper to emit CustomEvent on document (global)
    function emitDOMEvent(eventName, detail = {}) {
        try {
            const ev = new CustomEvent(eventName, {detail});
            document.dispatchEvent(ev);
        } catch (e) {
            // Ignore in very old browsers
            console.warn('account-cabinet: could not dispatch DOM event', eventName, e);
        }
    }

    function emit(name, data) {
        if (!listeners.has(name)) return;
        for (const cb of Array.from(listeners.get(name))) {
            try {
                cb(data);
            } catch (e) {
                console.error('account-cabinet listener error', e);
            }
        }
    }

    // Register panel initializer programmatically (name -> initFn(panelEl, payload))
    function registerPanel(name, initFn) {
        if (!name) throw new Error('registerPanel: name is required');

        const entry = panels.get(name) || {el: findPanelEl(name) || null, initFn: null, initialized: false};
        entry.initFn = initFn;
        panels.set(name, entry);
    }

    // Programmatic API: trigger a render only (without activating)
    function renderOnly(name, payload) {
        return renderPanel(name, payload);
    }

    // Attach tab click handlers and delegation for [data-account-cabinet-open]
    function bindUI() {
        // tabs
        $tabs.forEach(tab => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                const name = tab.getAttribute(TAB_ATTR);
                setActive(name);
            });
        });

        // delegation for elements that open panels:
        $container.addEventListener('click', (e) => {
            // find nearest opener
            const opener = e.target.closest(`[${OPEN_ATTR}]`);
            if (!opener) return;
            e.preventDefault();

            const val = opener.getAttribute(OPEN_ATTR);
            let payload = null;
            const payloadAttr = opener.getAttribute(PAYLOAD_ATTR);
            if (payloadAttr) {
                try {
                    payload = JSON.parse(payloadAttr);
                } catch (err) {
                    payload = payloadAttr;
                }
            }

            // allow opener to include inline "name:json" but default is val = panel name
            // if val contains ":" e.g. "group-info:123" or "group-info:{"id":1}" it's possible but we keep simple.
            const panelName = val;
            setActive(panelName, payload);
        });
    }

    function bindGlobalEvents() {
        document.addEventListener('account-cabinet:open', (e) => {
            const {name, payload} = e.detail || {};
            if (name) setActive(name, payload);
        });
        document.addEventListener('account-cabinet:render', (e) => {
            const {name, payload} = e.detail || {};
            if (name) renderOnly(name, payload);
        });
        document.addEventListener('account-cabinet:set-active', (e) => {
            // backward-compatible alias
            const {name, payload} = e.detail || {};
            if (name) setActive(name, payload);
        });
        document.addEventListener('account-cabinet:render-complete', (e) => {
            // backward-compatible alias
            $loader.style.display = 'none';
        });
    }

    function registerPanels() {
        try {


            registerPanel('my-progress', ($panel, payload) => {
                console.log('$panel', $panel)
                if ($panel) $panel.innerHTML = '';
                else return;
                initPersonalAccountTabProgressMy($panel);
            });
            registerPanel('view-history', ($panel, payload) => {
                if ($panel) $panel.innerHTML = '';
                else return;
                initPersonalAccountTabProgressHistory($panel);
            });

            registerPanel('profile-settings', ($panel, payload) => {
                if ($panel) $panel.innerHTML = '';
                initPersonalAccountTabProgressProfile($panel, userData);
            });

            registerPanel('self-progress', ($panel, payload) => {
                if ($panel) $panel.innerHTML = '';
                initPersonalAccountTabProgress($panel, userData);
            });

            registerPanel('students-progress', ($panel, payload) => {
                if ($panel) $panel.innerHTML = '';
                initPersonalAccountStudentsProgress($panel);
            });

            registerPanel('group-config', ($panel, payload) => {
                if ($panel) $panel.innerHTML = '';
                initPersonalAccountGroups($panel);
            });

            registerPanel('group-info', ($panel, payload) => {
                const groupId = payload && payload.groupId;
                if ($panel) $panel.innerHTML = '';
                initPersonalAccountGroup($panel, groupId);
            });

            console.log('panel initializers registered:', Array.from(panels.keys()));
        } catch (err) {
            console.error('account-cabinet: error registering panel initializers', err);
        }
    }


    // Initial activation
    async function init() {
        try {
            await fetchUserData();
        } catch (err) {
            // fetchUserData already logs; proceed without user data
            console.warn('account-cabinet: proceeding without user data');
        }
        initProfileCard();
        initBackButton();
        scanPanels();
        bindUI();
        bindGlobalEvents();
        await registerPanels();
        // choose start tab: aria-selected="true" or first tab
        const startTab = $tabs.find(t => t.getAttribute('aria-selected') === 'true') || $tabs[0];
        if (startTab) {
            const startName = startTab.getAttribute(TAB_ATTR);
            // do not emit global event on init
            setActive(startName, {}, {silent: true, focus: false});
        }
    }

    async function fetchUserData() {
        try {
            const response = await axios.get('/api/user');
            userData = response.data || {};
            console.log('userData', userData);
            return userData;
        } catch (error) {
            console.error('Error fetching user data:', error);
            userData = {};
            // rethrow if caller wants to handle; here we return null/empty
            return null;
        }
    }

    function initBackButton() {
        $navBack.addEventListener('click', () => {
            $navContainer.classList.remove('m-hide');
            $navBack.classList.remove('m-show');
            $contentContainer.classList.add('m-hide');
        });
    }
    function initProfileCard() {
        const $profileCard = $container.querySelector(`[${DATA_ATTR}-profile]`);
        if ($profileCard) {
            console.log('userData.avatar',userData.avatar);
            if (userData.avatar) {
                $profileCard.querySelector(`[${DATA_ATTR}-profile-img]`).src = 'storage/' + userData.avatar;
            }
            else {
                $profileCard.querySelector(`[${DATA_ATTR}-profile-img]`).style.display = 'none';
            }

            $profileCard.querySelector(`[${DATA_ATTR}-profile-name]`).textContent = userData.name;
            $profileCard.querySelector(`[${DATA_ATTR}-profile-role]`).textContent = userData.role?.name || '';
            $profileCard.querySelector(`[${DATA_ATTR}-profile-university]`).textContent = userData.university?.name || '';
        }
    }

    // Boot
    init();
}
